import type { createTemplateSchema } from "@/schemas/template/create";
import type { z } from "zod";
import { type CatalogsResponse } from "@/services/catalogService";
import { createContext, useContext } from "react";

interface TemplateContextType {
    onClearFile: () => void,
    onUpload: (file: File) => void,
    onComplete: (data: z.infer<typeof createTemplateSchema>) => void,
    isFetching: boolean,
    catalogs: CatalogsResponse | null
}

export const TemplateContext = createContext<TemplateContextType | null>(null);

export const useTemplateContext = () => {
    const context = useContext(TemplateContext);
    if (!context) {
        throw new Error("useTemplateContext must be used within a TemplateContextProvider");
    }
    return context;
}